import { isNotNil } from 'ramda'

import { DiscountCode, DiscountCodeCartValue } from './types'

enum DiscountCodeGrantingCondition {
  EMAIL = 'Email zweryfikowany w danym przedziale czasowym',
  MARKETING_CONSENT = 'Subskrypcja newslettera',
  ALL = 'Dla wszystkich'
}

export const checkValidCode = (rebate: DiscountCode, cart: DiscountCodeCartValue | null) => {
  const isCodeAvailable =
    rebate.isGranted &&
    !rebate.isUsed &&
    isNotNil(cart) &&
    (rebate.minimumOrderValue
      ? cart.itemsValue.gross.value >= rebate.minimumOrderValue.value
      : true)

  const isCodeUsed = rebate.isUsed
  const marketingNotConsent =
    rebate.grantingCondition ===
      DiscountCodeGrantingCondition.MARKETING_CONSENT &&
    !rebate.isGranted &&
    !rebate.isUsed
  const minimumOrderValueNotAchieved =
    rebate.minimumOrderValue && cart
      ? cart.itemsValue.gross.value < rebate.minimumOrderValue.value
      : false

  return {
    isCodeAvailable,
    isCodeUsed,
    marketingNotConsent,
    minimumOrderValueNotAchieved
  }
}

export const sortDiscountCodes = (
  rebateCodes: DiscountCode[],
  cart: DiscountCodeCartValue | null
) => {
  return rebateCodes
    .slice()
    .filter(rebate =>
      rebate.grantingCondition !== DiscountCodeGrantingCondition.EMAIL
        ? true
        : rebate.isGranted
    )
    .sort((a, b) => {
      const { isCodeAvailable: isAAvailable, isCodeUsed: isAUsed } =
        checkValidCode(a, cart)
      const { isCodeAvailable: isBAvailable, isCodeUsed: isBUsed } =
        checkValidCode(b, cart)

      if (isAAvailable && !isAUsed && (!isBAvailable || isBUsed)) return -1
      if (isBAvailable && !isBUsed && (!isAAvailable || isAUsed)) return 1

      if (!isAAvailable && !isAUsed && (isBAvailable || isBUsed)) return -1
      if (!isBAvailable && !isBUsed && (isAAvailable || isAUsed)) return 1

      if (isAUsed && !isBUsed) return 1
      if (isBUsed && !isAUsed) return -1

      return 0
    })
}

export const calculateAvailableDiscountCodes = (rebateCodes: DiscountCode[]) => {
  return rebateCodes.reduce((acc, rebate) => {
    const { isUsed } = rebate

    if (!isUsed) {
      acc++
    }

    return acc
  }, 0)
}

export const filterDiscountCodes = (
  rebateCodes: DiscountCode[],
  cart: DiscountCodeCartValue | null,
  filter: string
) => {
  return rebateCodes.filter(rebate => {
    const { isCodeAvailable, isCodeUsed } = checkValidCode(rebate, cart)

    if (filter === 'active') return isCodeAvailable && !isCodeUsed
    if (filter === 'inactive') return !isCodeAvailable && !isCodeUsed
    if (filter === 'used') return isCodeUsed

    return true
  })
}
